const icons = {
  aborted: "mdi-exit-to-app",
  accounts: "mdi-account-multiple",
  add_circle: "mdi-plus-circle",
  add_outline: "mdi-plus-circle-outline",
  alert: "mdi-alert",
  alert_circle: "mdi-alert-circle",
  arrow_left: "mdi-chevron-left",
  arrow_right: "mdi-chevron-right",
  automode: "mdi-auto-mode",
  book_marker: "mdi-book-marker-outline ",
  checked_circle: "mdi-checkbox-marked-circle",
  checked_circle_outline: "mdi-check-circle-outline",
  checkmark: "mdi-check-bold",
  close: "mdi-close",
  copy: "mdi-content-copy",
  dashboard: "mdi-view-dashboard",
  delete: "mdi-trash-can",
  declined: "mdi-delete-forever",
  desktop: "mdi-desktop-classic",
  download: "mdi-download",
  excel: "mdi-file-excel",
  filter: "mdi-filter",
  help: "mdi-help-circle",
  hide_password: "mdi-eye-off",
  hotel: "mdi-office-building",
  link_arrow_left: "mdi-arrow-left",
  link_arrow_right: "mdi-arrow-right",
  logout: "mdi-logout",
  menu: "mdi-menu",
  password: "mdi-lock",
  pasta: "mdi-pasta",
  payments: "mdi-cash-multiple",
  refreshChart: "mdi-refresh-circle",
  refreshDashBoard: "mdi-refresh-circle",
  remove_circle: "mdi-minus-circle",
  remove_outline: "mdi-minus-circle-outline",
  reservations: "mdi-bed",
  restore: "mdi-backup-restore",
  search: "mdi-magnify",
  show_password: "mdi-eye",
  snackbar_error: "mdi-alert-circle-outline",
  snackbar_info: "mdi-alert-circle-outline",
  snackbar_success: "mdi-check-circle-outline",
  sort_indicator: "mdi-arrow-up",
  username: "mdi-account",
  timer: "mdi-timer-sand",
  delivery: "mdi-truck-delivery",
  status_succes: "mdi-checkbox-multiple-marked",
  status_error: "mdi-checkbox-multiple-blank",
  stop: "mdi-minus-circle",
  table_menu: "mdi-dots-vertical",
  refreshTable: "mdi-table-refresh",
  selectHotel: "mdi-domain",
  deselectHotel: "mdi-domain-off",
  sync: "mdi-cog-sync",
  sync_success: "mdi-cog-transfer",
  res_new: "mdi-calendar-check",
  res_modification: "mdi-calendar-edit",
  res_cancellation: "mdi-calendar-remove",
  token: "mdi-key-chain",
  link: "mdi-link",
  authorize: "mdi-thumb-up-outline",
  capture: "mdi-camera-plus",
  notify: "mdi-email-arrow-right",
  connection: "mdi-connection",
  creditcard: "mdi-credit-card-check",
  virtualcard: "mdi-credit-card-clock",
  initialized: "mdi-credit-card-lock-outline",
  expire: "mdi-account-clock",
  email: "mdi-email",
  email_remove: "mdi-email-remove",
  email_check: "mdi-email-check",
  email_search: "mdi-email-search",
  email_receive: "mdi-email-arrow-left",
  email_open: "mdi-email-open",
  email_plus: "mdi-email-plus",
  email_lock: "mdi-email-lock",
  email_alert: "mdi-email-alert",
  editPassword: "mdi-account-key",
  resetRegistration: "mdi-qrcode",
  language: "mdi-web",
  progress: "mdi-progress-alert",
  clicked: "mdi-cursor-default-click",
  refunded: "mdi-cash-refund",
  eye: "mdi-eye",
  planned: "mdi-calendar-clock",
  guest: "mdi-account-key",
  travel_agent: "mdi-account-tie-hat",
  corporation: "mdi-domain",
  paylink: "mdi-link",
  captured_transactions: "mdi-sigma",
  authorized_transactions: "mdi-checkbox-multiple-marked-outline",
  declined_transactions: "mdi-login-variant",
  refunds: "mdi-credit-card-refund",
  checkout: "mdi-account-credit-card",
  report: "mdi-file-chart-outline",
  downloadPdf: "mdi-file-pdf-box",
  session_created: "mdi-cash-sync",
  terminal: "mdi-cash-register",
};

export { icons };
